import fetchServer from "../controllers/fetchServer";
import { URLdecode } from "../utils/url";
import { useRef } from "react";
import axios from "axios";
import { configurations } from "../configurations";

export function useMilesPoints() {
  const cancelGetTasksToken = useRef(null);

  const getMilesPointsTasks = async ({ setLoading, callback }) => {
    const params = URLdecode();
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/tasks`,
      api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.actions || []);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  return {
    getMilesPointsTasks,
  };
}
